import { defineStore } from 'pinia';
import { fetchQuizAnalytics } from '@/services/creatorEngagementService';

const emptyAnalytics = () => ({
  scope: { featureInstanceId: null, rangeKey: '30d', from: null, to: null },
  instances: [],
  summary: {
    startedCount: 0,
    leftCount: 0,
    finishedCount: 0,
    resultsReceivedCount: 0,
    uniqueStarters: 0,
    uniqueFinishers: 0,
    completionRatePercent: 0,
    leftRatePercent: 0,
    averageScorePercent: null,
    passRatePercent: null,
  },
  resultDistribution: [],
  byQuiz: [],
  recentAttempts: [],
});

export const useQuizAnalyticsStore = defineStore('quizAnalytics', {
  state: () => ({ loading: false, error: '', analytics: emptyAnalytics() }),
  actions: {
    async load(params = {}) {
      this.loading = true;
      this.error = '';
      try {
        const payload = await fetchQuizAnalytics(params);
        if (!payload?.success) throw new Error(payload?.error || 'Failed to load Quiz analytics');
        this.analytics = { ...emptyAnalytics(), ...payload };
        return this.analytics;
      } catch (error) {
        this.error = String(error?.message || 'Failed to load Quiz analytics');
        throw error;
      } finally {
        this.loading = false;
      }
    },
    reset() {
      this.error = '';
      this.analytics = emptyAnalytics();
    },
  },
});
